module.exports = __webpack_public_path__ + "static/media/noun-cog.b6fd0227.svg";